import { useState } from 'react';

import { Route, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useGetRolesQuery } from '@school_ify/schoolify-repository/src/teacher/types';

import TextField from 'clean/components/common/TextField/TextField';
import Button from 'clean/components/common/Button/Button';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as SearchIcon } from 'assets/icons/search.svg';
import ButtonDropDown from 'clean/components/common/ButtonDropDown/ButtonDropDown';
import Tabs from 'clean/components/common/Tabs/Tabs';
import ContentWithSidebar from 'clean/components/common/ContentWithSidebar/ContentWithSidebar';

import { ReactComponent as UserIcon } from '../../assets/icons/user.svg';
import { ReactComponent as UserGroupIcon } from '../../assets/icons/userGroup.svg';
import RoleTable from './components/RoleTable/RoleTable';
import ActivityLog from './components/ActivityLog/ActivityLog';
import UserTable from './components/UserTable/UserTable';

import './Permissions.scss';

const Permissions: React.FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();

  const tabs: {
    id: 'roles' | 'users';
    label: string;
    icon: React.FunctionComponent<
      React.SVGProps<SVGSVGElement> & {
        title?: string;
      }
    >;
  }[] = [
    {
      id: 'roles',
      label: t('permissions:PermissionsRoles'),
      icon: UserGroupIcon,
    },
    {
      id: 'users',
      label: t('permissions:PermissionsUsers'),
      icon: UserIcon,
    },
  ];

  const selectedTabId = tabs.find(tab => location.pathname.includes(tab.id))?.id || tabs[0].id;

  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const [search, setSearch] = useState('');
  const { data: roles } = useGetRolesQuery();

  return (
    <div className="permissionsPage">
      <ContentWithSidebar sidebar={<ActivityLog />}>
        <Tabs
          tabs={tabs}
          selectedTabId={selectedTabId}
          onChange={tab => {
            history.push(`/permissions/${tab.id}`);
          }}
        >
          <Route path="/permissions/roles">
            <div className="groupCustomContainer">
              <Button
                onClick={() => history.push('/permissions/roles/new')}
                label={t('permissions:PermissionsNewGroup')}
                color="primary"
                variant="filled"
                startIcon={<PlusIcon />}
              />
            </div>
          </Route>

          <Route path="/permissions/users">
            <div className="userCustomContainer">
              <div className="searchContainer">
                <TextField
                  value={search}
                  endIcon={<SearchIcon />}
                  className="search"
                  placeholder={t('common:Search')}
                  onChange={e => setSearch(e.target.value)}
                />
              </div>
              <ButtonDropDown
                emptyItemLabel="All groups"
                value={selectedRoleId}
                labelProperty="title"
                options={roles?.roles || []}
                onChange={value => setSelectedRoleId(value)}
              />
            </div>
          </Route>
        </Tabs>

        <Route path="/permissions/roles">
          <RoleTable />
        </Route>
        <Route path="/permissions/users">
          <UserTable selectedRoleId={selectedRoleId} search={search} />
        </Route>
      </ContentWithSidebar>
    </div>
  );
};

export default Permissions;
